import React from "react";
import image from "../../../../assets/floors.jpg";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Popover} from "antd";
import clsx from "clsx";
import styles from "./index.module.scss";

export default function Schema() {
  const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const block = searchParams.get('block');
  const onClick = (floorNumber) => () => {
    navigate(`/main/schema?block=${block}&floor=${floorNumber}`);
  };

  return (
      <svg width="4096" height="2078" viewBox="0 0 4096 2078" fill="none" xmlns="http://www.w3.org/2000/svg"
           xmlnsXlink="http://www.w3.org/1999/xlink" className={styles.svg}>
          <rect width="4096" height="2078" fill="url(#pattern0_89_14)"/>
          <Popover placement="leftBottom" content={1}>
              <path d="M71.5 1577H4044V1741H71.5V1577Z" fill="black" fillOpacity="0.4"
                    className={clsx(styles.floor, styles.floor1)} onClick={onClick(1)}/>
        </Popover>
          <Popover placement="leftBottom" content={2}>
              <path d="M72 1417H4044V1575.5H72V1417Z" fill="black" fillOpacity="0.4"
                    className={clsx(styles.floor, styles.floor1)} onClick={onClick(2)}/>
        </Popover>
          <Popover placement="leftBottom" content={3}>
              <path d="M72 1260L4044 1266.5V1416H72V1260Z" fill="black" fillOpacity="0.4"
                    className={clsx(styles.floor, styles.floor1)} onClick={onClick(3)}/>
        </Popover>
          <Popover placement="leftBottom" content={4}>
              <path d="M72 1104L4043.5 1112.5V1264.5L72 1259V1104Z" fill="black" fillOpacity="0.4"
                    className={clsx(styles.floor, styles.floor1)} onClick={onClick(4)}/>
        </Popover>
          <Popover placement="leftBottom" content={5}>
              <path d="M159 956.5H3957V1110L159 1103V956.5Z" fill="black" fillOpacity="0.4"
                    className={clsx(styles.floor, styles.floor1)} onClick={onClick(5)}/>
        </Popover>
        <defs>
            <pattern id="pattern0_89_14" patternContentUnits="objectBoundingBox" width="1" height="1">
                <use xlinkHref="#image0_89_14" transform="scale(0.000244141 0.000481232)"/>
          </pattern>
            <image id="image0_89_14" width="4096" height="2078" preserveAspectRatio="none" xlinkHref={image}/>
        </defs>
      </svg>

      // <svg
      //     width="3714"
      //     height="2768"
      //     viewBox="0 0 3714 2768"
      //     fill="none"
      //     xmlns="http://www.w3.org/2000/svg"
      //     xmlnsXlink="http://www.w3.org/1999/xlink"
      //     className={styles.svg}
      // >
      //   <rect width="3713.69" height="2767.14" fill="url(#pattern0_34_119)"/>
      //
      //   <Popover placement="rightBottom" content={2}>
      //     <path d="M989.168 2384.07H2224.5V2549.08H989.168V2384.07Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(2)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={3}>
      //     <path d="M990.529 2270.74H2225.4V2378.63H990.529V2270.74Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(3)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={4}>
      //     <path d="M990.982 2129.75H2225.86V2269.38H990.982V2129.75Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(4)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={5}>
      //     <path d="M990.982 1987.41H2225.86V2127.03H990.982V1987.41Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(5)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={6}>
      //     <path d="M990.982 1845.06H2225.86V1984.69H990.982V1845.06Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(6)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={7}>
      //     <path d="M990.982 1699.09H2225.86V1842.34H990.982V1699.09Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(7)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={8}>
      //     <path d="M990.982 1557.65H2225.86V1696.37H990.982V1557.65Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(8)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={9}>
      //     <path d="M990.982 1416.21H2225.86V1554.93H990.982V1416.21Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(9)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={10}>
      //     <path d="M990.982 1274.77H2225.86V1413.49H990.982V1274.77Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(10)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={11}>
      //     <path d="M990.982 1133.33H2225.86V1272.05H990.982V1133.33Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(11)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={12}>
      //     <path d="M990.982 991.89H2225.86V1130.61H990.982V991.89Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(12)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={13}>
      //     <path d="M990.982 846.823H2225.86V989.17H990.982V846.823Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(13)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={14}>
      //     <path d="M990.982 702.664H2225.86V844.104H990.982V702.664Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(14)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={15}>
      //     <path d="M990.982 558.505H2225.86V699.944H990.982V558.505Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(15)}
      //     />
      //   </Popover>
      //
      //   <Popover placement="rightBottom" content={16}>
      //     <path d="M990.982 414.345H2225.86V555.785H990.982V414.345Z"
      //           fill="black" fillOpacity="0.4"
      //           className={clsx(styles.floor, styles.floor1)}
      //           onClick={onClick(16)}
      //     />
      //   </Popover>
      //
      //   <defs>
      //     <pattern id="pattern0_34_119" patternContentUnits="objectBoundingBox" width="1" height="1">
      //       <use xlinkHref="#image0_34_119" transform="scale(0.000244141 0.000327654)"/>
      //     </pattern>
      //     <image
      //         id="image0_34_119"
      //         width="4096"
      //         height="3052"
      //         preserveAspectRatio="none"
      //         xlinkHref={image}
      //     />
      //   </defs>
      // </svg>


  );
}
